import { motion } from "framer-motion";
import useSeo from "@/hooks/useSeo";

const EASE = [0.16, 1, 0.3, 1];

export default function LegalPage({ testId, title, intro, sections, seo }) {
    useSeo(seo);
    return (
        <section
            data-testid={testId}
            className="mx-auto max-w-[760px] px-5 md:px-10 pt-24 md:pt-40 pb-24"
        >
            <div className="overflow-hidden">
                <motion.h1
                    initial={{ y: "110%" }}
                    animate={{ y: "0%" }}
                    transition={{ duration: 1, ease: EASE }}
                    className="font-[Fraunces] text-[38px] md:text-[60px] leading-[1.02] tracking-[-0.02em] text-[var(--hds-ink)]"
                    style={{ fontWeight: 300 }}
                >
                    {title}
                </motion.h1>
            </div>

            {intro && (
                <motion.p
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.9, ease: EASE, delay: 0.3 }}
                    className="mt-8 text-[17px] md:text-[18px] leading-[1.65] text-[var(--hds-ink)]/82"
                >
                    {intro}
                </motion.p>
            )}

            <div className="mt-12 space-y-12">
                {sections.map((s, i) => (
                    <motion.div
                        key={i}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-8%" }}
                        transition={{ duration: 0.7, ease: EASE }}
                    >
                        {s.h2 && (
                            <h2
                                className="font-[Fraunces] text-[24px] md:text-[28px] leading-[1.1] tracking-[-0.01em] mb-4 text-[var(--hds-ink)]"
                                style={{ fontWeight: 400 }}
                            >
                                {s.h2}
                            </h2>
                        )}
                        <div className="space-y-3 text-[15.5px] md:text-[16.5px] leading-[1.7] text-[var(--hds-ink)]/82">
                            {s.body.map((b, k) =>
                                Array.isArray(b) ? (
                                    <ul
                                        key={k}
                                        className="space-y-2 pl-1"
                                    >
                                        {b.map((li, j) => (
                                            <li
                                                key={j}
                                                className="flex gap-3"
                                            >
                                                <span
                                                    aria-hidden
                                                    className="mt-2.5 shrink-0 w-1.5 h-1.5 rounded-full bg-[var(--hds-clay)]"
                                                />
                                                <span>{li}</span>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p key={k}>{b}</p>
                                )
                            )}
                        </div>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
